<header-title [model]="headerTitle"></header-title>

<div class="py-4">
    <div class="d-flex">

      <div class="me-3" style="min-width: 240px;">
          <div class="grid" style="--bs-columns: 1; --bs-gap: .35rem;" role="tablist">
              <div class="g-col-1 text-center">
                  <button class="btn btn-primary-dark w-100 text-start flex-nowrap active" id="companyDetails-tab" data-bs-toggle="list" href="#companyDetails" role="tab" aria-controls="companyDetails" aria-selected="true" tabindex="-1">
                      <i class="fa fa-fw fa-star me-1"></i>Company Details
                  </button>
              </div>
              <div class="g-col-1 text-center">
                  <button class="btn btn-primary-dark w-100 text-start flex-nowrap" id="companyUsers-tab" data-bs-toggle="list" href="#companyUsers" role="tab" aria-controls="companyUsers" aria-selected="false" tabindex="-1">
                      <i class="fa fa-fw fa-users me-1"></i>Company Users
                  </button>
              </div>
              <div class="g-col-1 text-center" *ngIf="isAdmin">
                  <button class="btn btn-primary-dark w-100 text-start flex-nowrap" id="companyAuditTemplates-tab" data-bs-toggle="list" href="#companyAuditTemplates" role="tab" aria-controls="companyAuditTemplates" aria-selected="false" tabindex="-1">
                      <i class="fa fa-fw fa-users me-1"></i>Company Audit Templates
                  </button>
              </div>
              <div class="g-col-1 text-center">
                  <button class="btn btn-primary-dark w-100 text-start flex-nowrap" id="companyLenders-tab" data-bs-toggle="list" href="#companyLenders" role="tab" aria-controls="companyLenders" aria-selected="false" tabindex="-1">
                      <i class="fa fa-fw fa-dollar me-1"></i>Company Lenders
                  </button>
              </div>
              <div class="g-col-1 text-center">
                  <button class="btn btn-primary-dark w-100 text-start flex-nowrap" id="auditTargets-tab" data-bs-toggle="list" href="#auditTargets" role="tab" aria-controls="auditTargets" aria-selected="false" tabindex="-1">
                      <i class="fa fa-fw fa-bullseye me-1"></i>Audit Targets
                  </button>
              </div>
          </div>
      </div>

      <div class="flex-grow-1">
        <!-- Tab Contents -->
          <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade active show" id="companyDetails" role="tabpanel" aria-labelledby="companyDetails-tab">
                  <div class="card mb-4">

                      <div class="card-header d-flex align-items-center justify-content-between">
                          <h3 class="text-gray-600 m-0"><i class="fa fa-fw fa-info-circle me-2"></i>Company Overview</h3>
                      </div>

                      <div class="card-body py-3">


                          <!-- Content for Company Users goes here -->
                          <form *ngIf="companyDetailsFormGroup" (submit)="updateCompany()" [formGroup]="companyDetailsFormGroup">
                              <div class="row">
                                  <div class="col-md-12 text-end">
                                      <button *ngIf="isEditMode && (!users?.length && !companyAuditTemplates?.length)" type="button" class="btn btn-danger me-3" (click)="selectedCompanyId=companyDetailsFormGroup.value.id; confirmation.showMessage();">Delete Company</button>
                                      <button *ngIf="isEditMode && isAdmin && (users?.length>0 || companyAuditTemplates?.length>0)" type="button" class="btn btn-danger me-3" (click)="openCannotDeleteCompany(cannotDeleteCompany);">Delete Company</button>
                                      <button class="btn btn-primary" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">Edit</button>
                                      <button class="btn btn-outline-primary" type="button" (click)="toggleEditMode()" *ngIf="isEditMode">Cancel</button>
                                  </div>
                              </div>
                              <div *ngIf="!companyDetailsModel.isActive" class="alert alert-warning mt-3" role="alert">
                                  This Company is not active.
                              </div>
                              <div *ngIf="isEditMode && !isAdmin" class="alert alert-warning mt-3" role="alert">
                                  Some details can only be updated by Comply 365 Administrators. To update restricted data please contact your Comply 365 representative.
                              </div>
                              <error-message [errors]="errors"></error-message>
                              <h4 class="mt-5 text-primary">Company Details</h4>
                              <div class="row mt-3">
                                  <div class="col-md-6 col-lg-4">
                                      <div class="form-group">
                                          <label class="control-label text-default">
                                              Legal Name
                                          </label>
                                          <input type="text" class="form-control" formControlName="legalName" [readOnly]="!isEditMode||!isAdmin" />
                                      </div>
                                  </div>
                                  <div class="col-md-6 col-lg-4">
                                      <div class="form-group">
                                          <label class="control-label text-default">
                                              Trading Name
                                          </label>
                                          <input id="tradingName" name="tradingName" class="form-control" formControlName="tradingName" [readOnly]="!isEditMode||!isAdmin" />
                                      </div>
                                  </div>
                                  <div class="col-md-6 col-lg-4">
                                      <div class="form-group">
                                          <label class="control-label text-default">
                                              Company Type
                                          </label>
                                          <input *ngIf="!isEditMode||!isAdmin" type="text" id="tmp" name="tmp" class="form-control" [readOnly]="true" value="{{companyTypeString}}" />
                                          <select *ngIf="isEditMode&&isAdmin" name="companyTypeId" class="form-control" formControlName="companyTypeId">
                                              <option *ngFor="let companyType of companyTypesList" [value]="companyType.id">{{companyType.description}}</option>
                                          </select>
                                      </div>
                                  </div>
                              </div>
                              <div class="row mt-3">
                                  <div class="col-md-6 col-lg-4">
                                      <label class="control-label text-default">
                                          Aggregator
                                      </label>
                                      <input *ngIf="!isEditMode||!isAdmin" type="text" id="tmp3" name="tmp3" class="form-control" [readOnly]="true" value="{{aggregatorString}}" />
                                      <select *ngIf="isEditMode&&isAdmin" name="aggregatorId" class="form-control" formControlName="aggregatorId">
                                          <option [ngValue]="null">None</option>
                                          <option *ngFor="let aggregator of aggregatorsList" [value]="aggregator.id">{{aggregator.name}}</option>
                                      </select>
                                  </div>
                                  <div class="col-md-6 col-lg-4">
                                      <label class="control-label text-default">
                                          Parent Entity
                                      </label>
                                      <input *ngIf="!isEditMode||!isAdmin" type="text" id="tmp2" name="tmp2" class="form-control" [readOnly]="true" value="{{parentString}}" />
                                      <select *ngIf="isEditMode&&isAdmin" name="parentId" class="form-control" formControlName="parentId">
                                          <option [ngValue]="null">None</option>
                                          <option *ngFor="let company of companiesList" [value]="company.id">{{company.legalName}}</option>
                                      </select>
                                  </div>
                                  <div class="col-md-6 col-lg-4">
                                      <label class="control-label text-default">
                                          Parent Entity Access (On: Full / Off: Read-Only)
                                      </label>
                                      <input type="checkbox" id="parentFullAccess" name="parentFullAccess" class="form-control" formControlName="parentFullAccess" appToggle [isDisabled]="!isEditMode" />
                                  </div>
                              </div>
                              <div class="row mt-3">
                                  <div class="col-md-6 col-lg-3">
                                      <div class="form-group">
                                          <label class="control-label text-default">ACL Number <span *ngIf="companyDetailsFormGroup.value.companyTypeId==1">authorised under</span></label>
                                          <input type="text" id="aclNr" name="aclNr" class="form-control" formControlName="aclNr" [readOnly]="!isEditMode||!isAdmin" />
                                          <div *ngIf="aclNr?.invalid">
                                              <label class="control-label text-danger" *ngIf="aclNr?.errors.required">
                                                  Required.
                                              </label>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-6 col-lg-3" *ngIf="companyDetailsFormGroup.value.companyTypeId==1">
                                      <div class="form-group">
                                          <label class="control-label text-default">ACR Number</label>
                                          <input type="text" id="acrNr" name="acrNr" class="form-control" formControlName="acrNr" [readOnly]="!isEditMode||!isAdmin" />
                                          <div *ngIf="acrNr?.invalid">
                                              <label class="control-label text-danger" *ngIf="acrNr?.errors.required">
                                                  Required.
                                              </label>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-6 col-lg-3">
                                      <div class="form-group">
                                          <label class="control-label text-default">ACN</label>
                                          <input type="text" id="acn" name="acn" class="form-control" formControlName="acn" [readOnly]="!isEditMode||!isAdmin" />
                                      </div>
                                  </div>
                                  <div class="col-md-6 col-lg-3">
                                      <div class="form-group">
                                          <label class="control-label text-default">ABN</label>
                                          <input type="text" id="abn" name="abn" class="form-control" formControlName="abn" [readOnly]="!isEditMode||!isAdmin" />
                                          <div *ngIf="abn?.invalid">
                                              <label class="control-label text-danger" *ngIf="abn?.errors.required">
                                                  Required.
                                              </label>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <hr class="mt-5" />
                              <h4 class="mt-2 text-primary">Key Dates</h4>
                              <div class="row">
                                  <div class="col-md-4 col-lg-3">
                                      <div class="form-group">
                                          <label class="control-label text-default">ACL Anniversary Date</label>
                                          <input id="aclExpiry"
                                                 name="aclExpiry"
                                                 class="form-control"
                                                 formControlName="aclExpiry"
                                                 type="text"
                                                 placeholder="DD/MM/YYYY"
                                                 bsDatepicker
                                                 [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }"
                                                 *ngIf="isEditMode">
                                          <input
                                                 name="aclExpiry"
                                                 class="form-control"
                                                 [value]="companyDetailsFormGroup.get('aclExpiry').value | date: 'dd/MM/yyyy'"
                                                 type="text"
                                                 placeholder="DD/MM/YYYY"
                                                 readonly
                                                 *ngIf="!isEditMode">
                                      </div>
                                      </div>
                                  <div class="col-md-4 col-lg-3">
                                      <div class="form-group">
                                          <label class="control-label text-default">PII Expiry Date</label>
                                          <input id="piExpiry"
                                                 name="piExpiry"
                                                 class="form-control"
                                                 formControlName="piExpiry"
                                                 type="text"
                                                 placeholder="DD/MM/YYYY"
                                                 bsDatepicker
                                                 [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }"
                                                 *ngIf="isEditMode">
                                          <input name="piExpiry"
                                                 class="form-control"
                                                 [value]="companyDetailsFormGroup.get('piExpiry').value | date: 'dd/MM/yyyy'"
                                                 type="text"
                                                 placeholder="DD/MM/YYYY"
                                                 readonly
                                                 *ngIf="!isEditMode">
                                      </div>
                                    </div>
                                  <div class="col-md-4 col-lg-3">
                                      <div class="form-group">
                                          <label class="control-label text-default">AFCA Membership Expiry Date</label>
                                          <input id="afcaExpiry"
                                                 name="afcaExpiry"
                                                 class="form-control"
                                                 formControlName="afcaExpiry"
                                                 type="text"
                                                 placeholder="DD/MM/YYYY"
                                                 bsDatepicker
                                                 [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }"
                                                 *ngIf="isEditMode">
                                          <input name="afcaExpiry"
                                                 class="form-control"
                                                 [value]="companyDetailsFormGroup.get('afcaExpiry').value | date: 'dd/MM/yyyy'"
                                                 type="text"
                                                 placeholder="DD/MM/YYYY"
                                                 readonly
                                                 *ngIf="!isEditMode">
                                      </div>
                                  </div>
                              </div>
                              
                              <hr class="mt-5" />
                              <h4 class="mt-2 text-primary">Contact Details</h4>
                              <div class="row mt-3">
                                  <div class="col-md-12 col-lg-4">
                                      <div class="form-group">
                                          <label class="control-label text-default">Web Site</label>
                                          <input type="email" id="website" name="website" class="form-control" formControlName="website" [readOnly]="!isEditMode" />
                                      </div>
                                  </div>
                                  <div class="col-md-4 col-lg-2">
                                      <div class="form-group">
                                          <label class="control-label text-default">Mobile Number</label>
                                          <input type="text" id="mobileNr" name="mobileNr" class="form-control" formControlName="mobileNr" [readOnly]="!isEditMode" />
                                      </div>
                                  </div>
                                  <div class="col-md-4 col-lg-2">
                                      <div class="form-group">
                                          <label class="control-label text-default">Phone Number</label>
                                          <input type="text" id="phoneNr" name="phoneNr" class="form-control" formControlName="phoneNr" [readOnly]="!isEditMode" />
                                      </div>
                                  </div>
                                  <div class="col-md-4 col-lg-2">
                                      <div class="form-group">
                                          <label class="control-label text-default">Fax Number</label>
                                          <input type="text" id="faxNr" name="faxNr" class="form-control" formControlName="faxNr" [readOnly]="!isEditMode" />
                                      </div>
                                  </div>
                              </div>
                              <hr class="mt-5" />
                              <h4 class="mt-2 text-primary">Account Details</h4>
                              <div class="row mt-3">
                                  <div class="col-md-4 col-lg-2">
                                      <label class="control-label text-default">
                                          Is Active
                                      </label>
                                      <div class="p-2" *ngIf="!isEditMode||!isAdmin">
                                          <span class="fa fa-check text-success" *ngIf="companyDetailsFormGroup.value.isActive"></span>
                                          <span class="fa fa-times text-danger" *ngIf="!companyDetailsFormGroup.value.isActive"></span>
                                      </div>
                                      <input type="checkbox" id="isActive" name="isActive" class="form-control" formControlName="isActive" appToggle [isDisabled]="!isEditMode||!isAdmin" *ngIf="isEditMode&&isAdmin" />
                                  </div>
                                  <div class="col-md-8 col-lg-4">
                                      <label class="control-label text-default">
                                          Max number of Users allocated to this account
                                      </label>
                                      <input type="number" id="usersNr" name="faxNr" class="form-control" formControlName="usersNr" [readOnly]="!isEditMode||!isAdmin" />
                                      <div *ngIf="usersNr?.invalid">
                                          <label class="control-label text-danger" *ngIf="usersNr?.errors.min">
                                              At least one user must be allocated to this account
                                          </label>
                                      </div>
                                  </div>
                              </div>
                              <div class="row mt-3" *ngIf="isAdmin">
                                  <div class="col-md-12">
                                      <div class="form-group">
                                          <label class="control-label text-default"> Notes </label>
                                          <textarea class="form-control" formControlName="notes" [readOnly]="!isEditMode" rows="2"></textarea>
                                      </div>
                                  </div>
                              </div>
                              <footer class="panel-footer mt-3">
                                  <div class="row">
                                      <div class="col-12 text-end">
                                          <button class="btn btn-outline-primary" type="button" (click)="onBack()" *ngIf="!isEditMode">Back</button>
                                          <button class="btn btn-primary ms-3" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">Edit</button>
                                          <button class="btn btn-outline-primary" type="button" (click)="toggleEditMode()" *ngIf="isEditMode">Cancel</button>
                                          <button class="btn btn-success ms-3" type="submit" *ngIf="isEditMode">Save</button>
                                      </div>
                                  </div>
                              </footer>
                          </form>


                      </div>
                  </div>
              </div>

              <div class="tab-pane fade" id="companyUsers" role="tabpanel" aria-labelledby="companyUsers-tab">
                  <div class="card mb-4">
                      <div class="card-header d-flex align-items-center justify-content-between">
                          <h3 class="text-gray-600 m-0"><i class="fa fa-fw fa-users me-2"></i>{{companyDetailsModel?.legalName}} Company Users</h3>
                      </div>
                      <div class="card-body py-3">
                          <!-- Content for Company Users goes here -->
                          <app-company-users [companyId]="companyId"></app-company-users>
                      </div>
                  </div>
              </div>

              <div class="tab-pane fade" id="companyAuditTemplates" role="tabpanel" aria-labelledby="companyAuditTemplates-tab" *ngIf="isAdmin">
                  <div class="card mb-4">
                      <div class="card-header d-flex align-items-center justify-content-between">
                          <h3 class="text-gray-600 m-0"><i class="fa fa-fw fa-users me-2"></i>{{companyDetailsModel?.legalName}} Company Audit Templates</h3>
                      </div>
                      <div class="card-body py-3">
                          <!-- Content for Company Users goes here -->
                          <app-company-audit-templates-list [companyId]="companyId"></app-company-audit-templates-list>
                      </div>
                  </div>
              </div>

              <div class="tab-pane fade" id="companyLenders" role="tabpanel" aria-labelledby="companyLenders-tab">
                  <div class="card mb-4">
                      <div class="card-header d-flex align-items-center justify-content-between">
                          <h3 class="text-gray-600 m-0"><i class="fa fa-fw fa-users me-2"></i>{{companyDetailsModel?.legalName}} Lender Permissions</h3>
                      </div>
                      <div class="card-body py-3">
                          <!-- Content for Company Lenders goes here -->
                          <app-company-lenders [companyId]="companyId"></app-company-lenders>
                      </div>
                  </div>
              </div>
              <div class="tab-pane fade" id="auditTargets" role="tabpanel" aria-labelledby="auditTargets-tab">
                  <div class="card mb-4">
                      <div class="card-header d-flex align-items-center justify-content-between">
                          <h3 class="text-gray-600 m-0"><i class="fa fa-fw fa-users me-2"></i>{{companyDetailsModel?.legalName}} Audit Targets</h3>
                      </div>
                      <div class="card-body py-3">
                          <!-- Content for Audit Targets goes here -->
                          <app-audit-targets [companyId]="companyId"></app-audit-targets>
                      </div>
                  </div>
              </div>
          </div>

      </div>

    </div>
  </div>


<app-alert-message (successClicked)="successClicked($event)"
                   (onHide)="onHide($event)"
                   [title]="'Success'"
                   [message]="'Company updated'">
</app-alert-message>

<app-confirmation-message #confirmation (confirmationClicked)="deleteCompany();"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this company?'">
</app-confirmation-message>

<ng-template #cannotDeleteCompany let-modal>
    <div class="modal-header">
        <div class="container">
            <div class="row">
                <div class="col-10">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="modal-title" id="modal-basic-title">Companies with assigned Users or Audit Templates cannot be deleted.</h4>
                        </div>
                        <div class="col-12">
                            <p id="modal-basic-content">Remove all Users and Audit Templates to continue.</p>
                            <p id="modal-basic-content"><span *ngIf="companyAuditTemplates?.length>0">{{companyAuditTemplates.length}} Audit Template(s)</span> <span *ngIf="companyAuditTemplates?.length > 0 && users?.length > 0"> & </span> <span *ngIf="users?.length>0">{{users.length}} User(s)</span></p>
                        </div>
                    </div>
                </div>
                <div class="col-2">
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
